import { NgModule } from '@angular/core';
import { ErpDocumentService } from './service/erp-document-service';

/**
 * CoreModule for documents.
 */
@NgModule( {
    imports: [
    ],
    declarations: [
    ],
    exports: [
    ],
    providers: [
        ErpDocumentService
    ],
} )

export class DocumentCoreModule {
}
